import React, { useEffect, useState } from "react";
import styles from "./homePage.module.css";
import { Link } from "react-router-dom";
import video from "../../assets/videos/Background.mp4";
import { useLanguage } from "../../languageContext";

const HomePage: React.FC = () => {
  const [displayText, setDisplayText] = useState<string>("");
  const [currentWordIndex, setCurrentWordIndex] = useState<number>(0);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [typingSpeed, setTypingSpeed] = useState<number>(150);
  const { translate } = useLanguage();

  const words = [
    translate('m1'),
    translate('m2'),
    translate('m3'),
    translate('m4'),
    translate('m5'),
  ];

  useEffect(() => {
    const handleTyping = () => {
      const currentWord = words[currentWordIndex];

      if (isDeleting) {
        setDisplayText(currentWord.substring(0, displayText.length - 1));
        setTypingSpeed(75);
      } else {
        setDisplayText(currentWord.substring(0, displayText.length + 1));
        setTypingSpeed(150);
      }

      if (!isDeleting && displayText === currentWord) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && displayText === '') {
        setIsDeleting(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, currentWordIndex, words, typingSpeed]);

  return (
    <div className={styles.container}>
      <video className={styles.backgroundVideo} autoPlay loop muted playsInline>
        <source src={video} type="video/mp4" />
      </video>
      <div className={styles.overlay}></div>

      {/* Floating particles */}
      <div className={styles.particles}>
        <div className={styles.particle}></div>
        <div className={styles.particle}></div>
        <div className={styles.particle}></div>
        <div className={styles.particle}></div>
        <div className={styles.particle}></div>
      </div>

      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>
          <div className={styles.typingContainer}>
            <span className={styles.typingText}>
              {displayText}
            </span>
          </div>
        </h1>

        <p className={styles.heroSubtitle}>
          {translate('m6')}
        </p>

        <Link to="/workzone" className={styles.ctaButton}>
          {translate('m7')}
        </Link>
      </div>
    </div>
  );
};

export default HomePage;